import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ReturnDetails } from "../../returns.types";
import { requestReturnsDetailsByIds } from "./returnsDetailsByIds.request";

const useReturnsDetailsByIds = (
  options?: MutationOptions<ReturnDetails[], ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestReturnsDetailsByIds,
    ...options
  });
};

export default useReturnsDetailsByIds;
